export const LEGEND_SATELLITE = {
  wood: ["#83b760", "rgb(0, 19, 124)", "#5E0000"],
  scrub: ["#c7e99e", "rgb(80, 106, 252)", "#B00303"],
  crop: ["#e7f8b0", "rgb(143, 160, 255)", "#E76506"],
  grass: ["#d7f2a8", "rgb(207, 214, 255)", "#DAC507"],
  other: ["rgb(255, 255, 255)", "rgb(255, 147, 147)", "#55C100"],
};

export const LEGEND_FIRE_DANGER_SHP = {
  low: ['#65CDAA'],
  elevated: ['#F1CA4B'],
  high: ['#E33022'],
};

export const LEGEND_EFFIS_VALUES = [0, 20, 40, 60, 80, 100];